import m, { type Vnode } from 'mithril'
import { initMithrilComponent } from '@client-shared/utils/mithril'
import clsx from 'clsx'

import s from './icon-button.module.scss'

interface Attrs extends m.Attributes {
	icon: Vnode | m.Component
	onClick?: () => void
	class?: string
	disabled?: boolean
}

function isVnode(obj: Vnode | m.Component): obj is Vnode {
	return obj != null && typeof obj === 'object' && Object.hasOwn(obj, 'tag')
}

const IconButton = initMithrilComponent<Attrs>()

IconButton.view = (vnode) => {
	const { icon, onClick, class: add_class, disabled = false, ...button_attrs } = vnode.attrs

	return m(
		'button',
		{
			type: 'button',
			class: clsx(s.icon_button, add_class),
			onclick: onClick,
			disabled,
			...button_attrs,
		},
		isVnode(icon) ? icon : m(icon),
	)
}

export default IconButton
